import { getChannelAPIPath } from '@treasury/core/http';

NotificationConfigurationService.$inject = ['$resource'];

export default function NotificationConfigurationService($resource) {
    return {
        getNotificationConfigurations,
        save,
    };

    function getNotificationConfigurations() {
        return $resource(`${getChannelAPIPath()}notificationConfiguration/`).get().$promise;
    }

    function save(configuration) {
        const resource = $resource(
            `${getChannelAPIPath()}notificationConfiguration/`,
            {},
            { update: { method: 'PUT' } }
        );
        return resource.update(configuration).$promise;
    }
}
